import type { RouteComponentProps } from '@reach/router';
import { Router } from '@reach/router';
import type { FC } from 'react';

import { EmptyState } from '@xing-com/empty-state';
import { IllustrationEmptyStateInfo } from '@xing-com/illustrations';

import { ShareFrame } from '../components/share-frame/share-frame';
import { ShareZenView } from '../components/share-zen-view/share-zen-view';

const EmptyStateRoute: FC<RouteComponentProps> = () => (
  <EmptyState
    illustration={IllustrationEmptyStateInfo}
    size="medium"
    variant="default"
    withBackground
  />
);

export const Routes: FC = () => (
  <Router>
    <EmptyStateRoute path="*" />
    <ShareZenView path="/" />
    <ShareFrame path="/spi" />
  </Router>
);
